import { render, staticRenderFns } from "./personal_bio.vue?vue&type=template&id=3eaf0155&"
import script from "./personal_bio.vue?vue&type=script&lang=js&"
export * from "./personal_bio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports